import type { Timestamp } from 'firebase/firestore';

export type BusinessHours = Record<
  '0' | '1' | '2' | '3' | '4' | '5' | '6',
  { start: string; end: string; closed?: boolean }
>;

export interface SecuritySettings {
  passwordMinLength: number;
  passwordRequireUppercase: boolean;
  passwordRequireLowercase: boolean;
  passwordRequireNumber: boolean;
  passwordRequireSymbol: boolean;
  passwordRotationDays: number;
  passwordHistoryCount: number;
  passwordExpiryWarningDays: number;
  passwordCannotContainName: boolean;
}

export interface GeneralSettings {
  companyName: string;
  companyLogoUrl?: string;
  timezone: string;
  businessHours: BusinessHours;
  contactEmail?: string;
  contactPhone?: string;
  /** Config de WhatsApp (sub-objeto em general). Ver OperationSubtab / backend GeneralSettings. */
  whatsapp?: {
    autoFinalizeHours?: number;
    sendReadReceipts?: boolean;
    templateSyncInterval?: 'manual' | '3h' | '6h' | '12h';
    /** Intervalo mínimo (min) entre templates MANUAIS pro mesmo paciente. Ausente → 60 (ligado). 0 = desligado. */
    manualTemplateCooldownMinutes?: number;
    /** Retencao da midia recebida. Ausente → LIGADO (lido como `!== false`, igual ao cron). */
    mediaRetentionEnabled?: boolean;
  };
  /** Telefones (E.164) que recebem template WA de alerta de sistema. */
  alertPhones?: string[];
  /** Nome do template WA de alerta de sistema (2 params: título, mensagem). Default 'gaia_system_alert'. */
  systemAlertTemplateName?: string;
  email?: {
    fromName?: string;
    replyTo?: string;
    digestSendTime?: string;
    dailyDigestEnabled?: boolean;
  };
  security: SecuritySettings;
  updatedAt: Timestamp;
  updatedBy: string;
}

export const DEFAULT_SECURITY_SETTINGS: SecuritySettings = {
  passwordMinLength: 12,
  passwordRequireUppercase: true,
  passwordRequireLowercase: true,
  passwordRequireNumber: true,
  passwordRequireSymbol: true,
  passwordRotationDays: 90,
  passwordHistoryCount: 5,
  passwordExpiryWarningDays: 7,
  passwordCannotContainName: true,
};

export const WEEKDAY_LABELS: Record<keyof BusinessHours, string> = {
  '0': 'Domingo',
  '1': 'Segunda',
  '2': 'Terça',
  '3': 'Quarta',
  '4': 'Quinta',
  '5': 'Sexta',
  '6': 'Sábado',
};
